import { apiClient } from '@/shared/services/client'
import type { ColaFilters, ColaListResponse } from '@/modules/bd-unificada/types/cola'

const BASE = '/bd-unificada/cola'

export async function getCola(filters?: ColaFilters): Promise<ColaListResponse> {
  const response = await apiClient.get<ColaListResponse>(`${BASE}/`, { params: filters })
  return response.data
}

export async function aprobarItem(id: string): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.post(`${BASE}/${id}/aprobar`)
  return response.data
}

export async function rechazarItem(id: string): Promise<{ message: string; success: boolean }> {
  const response = await apiClient.post(`${BASE}/${id}/rechazar`)
  return response.data
}
